export function post<T>(url: string, body: any) {
	return fetch(url, {
		body: JSON.stringify(body),
		headers: {
			'Content-Type': 'application/json'
		},
		method: 'POST',
	})
		.then(resp => {
			if (!resp.ok) {
				return Promise.reject(new Error('Request failed'))
			}
			return resp.json()
		})
}

export function get<T>(url: string) {
	return fetch(url)
		.then(resp => {
			if (!resp.ok) {
				return Promise.reject(new Error('Request failed'))
			}
			return resp.json()
		})
}


// WEBPACK FOOTER //
// ./src/HTTPLib.tsx